import {
  RouterProvider,
  createBrowserRouter,
  useRouteError,
} from 'react-router-dom';
import Home from '../pages/Home';
import { authValidator, homeValidator, loginValidator } from './helpers';
import Login from '../pages/Login';
import Auth from '../pages/Auth';
import { useAppSelector } from '../../core/hooks/storeHooks';

function ErrorBoundary() {
  let error = useRouteError();
  console.error(error);
  return <div>Error!</div>;
}

const AppRouter = () => {
  const isAuthenticated = useAppSelector((state) => !!state.auth.user.id);
  const router = createBrowserRouter([
    {
      path: '/',
      Component: Home,
      caseSensitive: true,
      loader: () => homeValidator(isAuthenticated),
      errorElement: <ErrorBoundary />,
    },
    {
      path: '/login',
      Component: Login,
      caseSensitive: true,
      loader: loginValidator,
    },
    {
      path: '/auth',
      Component: Auth,
      caseSensitive: true,
      loader: () => authValidator(isAuthenticated),
    },
    {
      path: '*',
      loader: () => authValidator(isAuthenticated),
    },
  ]);

  return <RouterProvider router={router} />;
};

export default AppRouter;
